import { get, each } from 'lodash';

export default {
  validate: (question, visible, answers, payload, config, ln) => {
    let messaging;
    let month, day, year;

    // payload should contain exactly 3 questions (for month, day, year questions)
    if (payload.question.length !== 3) {
      return {
        messaging
      }
    }

    each(payload.question, questionId => {
      const part = get(answers[questionId], 'part');

      if (get(part, 'metadata.NumericalMonth')) {
        month = get(part, 'metadata.NumericalMonth');
      }

      if (get(part, 'metadata.IsDateDay')) {
        day = get(part, 'metadata.IsDateDay');
      }

      if (get(part, 'metadata.IsDateYear')) {
        year = get(part, 'metadata.IsDateYear');
      }
    });

    // if we're missing answers for month/day/year, nothing to do
    if (!month || !day || !year) {
      return {
        messaging
      }
    }

    let nearDate = new Date();
    let farDate = new Date();

    nearDate.setDate(nearDate.getDate() + 42); // 6 weeks
    farDate.setMonth(farDate.getMonth() + 4); // 4 months

    const gradDate = new Date(year, month, day);

    // if graduation date is between 6 weeks from now and 4 months from now, show guarantee text, otherwise warn
    if (nearDate <= gradDate && farDate >= gradDate) {
      messaging = {
        message: (config.features.guaranteeApprovedText[ln] || config.features.guaranteeApprovedText['en_US']),
        class: 'valid',
        displayBeforeSubmission: true
      }
    } else {
      messaging = {
        message: (config.features.guaranteeIsNotApprovedText[ln] || config.features.guaranteeIsNotApprovedText['en_US']),
        class: 'warning',
        displayBeforeSubmission: true
      }
    }

    return {
      messaging
    }
  }
};



// WEBPACK FOOTER //
// ./src/base/scripts/constraints/GuaranteeText.js